<template>
   <div class="dilu-page">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="auto"
      class="demo-ruleForm"
    >
      <el-form-item prop="question">
        <el-input
          type="textarea"
          placeholder="输入想问的..."
          rows="6"
          v-model="ruleForm.question"
          style="width:800px;"
        ></el-input>
      </el-form-item>
      <div style="display:flex;direction:row;">
        <el-form-item prop="model">
          <el-select v-model="ruleForm.model">
            <el-option label="DeepSeek-V3-0324" value="deepseek-chat" />
            <el-option label="DeepSeek-R1-0528" value="deepseek-reasoner" />
          </el-select>
        </el-form-item>
        <span slot="footer" class="dialog-footer" style="margin-left:20px;">
            <el-button :loading="isLoading" type="primary" @click="submit">提 问</el-button>
        </span>
      </div>
    </el-form>
    <div style="margin-top:20px;font-family:PingFang SC,Arial,sans-serif;">
      <div v-if="reasoning!=''" style="font-weight:bold;line-height:29px;font-size:18px;">推理过程</div>
      <div v-if="reasoning!=''" style="font-size:18px;">{{ reasoning }}</div>
      <br/>
      <div v-if="reply!=''" style="font-weight:bold;line-height:29px;font-size:18px;">回复信息</div>
      <div v-if="reply!=''" style="line-height:29px;font-size:18px;">{{ reply }}</div>
    </div>
   </div>
 </template>
 
 
 <script>
 import { mapState } from "vuex";
 export default {
   data() {
     return {
       ruleForm: {
        question: "",
        model:"deepseek-chat"
      },
      reply: "",
      reasoning: "",
      isLoading: false
     };
   },
   components: {
   
   },
   computed: {
     ...mapState(["buttonTextColor"]),
   },
   mounted() {
    
   },
   methods: {
     submit() {
      this.isLoading=true;
      this.reply="";
      this.reasoning="";
      this.request
        .aiAsk({ question: this.ruleForm.question, model: this.ruleForm.model })
        .then((res) => {
          this.isLoading=false;
          this.reply=res.data.reply;
          if (res.data.reasoning!=null&&res.data.reasoning.length>0) {
            this.reasoning=res.data.reasoning;
          }
        });
    },
   },
 };
 </script>
 
 <style scoped>
 </style>